/** Speclogician blue glass cards on light marketing sections. */
export const SL_GLASS_TITLE =
  'mb-3 text-xl leading-snug font-light! text-blue-600 sm:text-2xl dark:text-blue-400'

export const SL_GLASS_SURFACE =
  'border-blue-600/60 dark:border-blue-500/40 dark:bg-slate-900/50'

export const SL_GLASS_BODY = 'text-slate-600 dark:text-slate-300/90'

/** Getting-started step cards — zinc/neutral glass, not blue marketing tint. */
export const SL_STEP_CARD_SURFACE =
  'h-full space-y-3 border-zinc-300/60 bg-zinc-50 dark:bg-slate-400/15'
